{
  "version": "12.17.0",
  "source": "https://raw.githubusercontent.com/vscode-icons/vscode-icons/v12.17.0/src/iconsManifest/languages.ts",
  "generatedAt": "2026-02-17T20:03:11.362Z",
  "extensionToLanguageId": {
    "as": "actionscript",
    "ada": "ada",
    "prw": "advpl",
    "affect": "affectscript",
    "agda": "agda",
    "al": "al",
    "alloy": "alloy",
    "ansible": "ansible",
    "g4": "antlr",
    "any": "anyscript",
    "htaccess": "apacheconf",
    "cls": "apex",
    "apib": "apiblueprint",
    "apl": "apl",
    "applescript": "applescript",
    "adoc": "asciidoc",
    "asp": "asp",
    "asm": "arm",
    "astro": "astro",
    "ats": "ats",
    "ahk": "ahk",
    "au3": "autoit",
    "am": "automake",
    "avcs": "avro",
    "azcli": "azcli",
    "azure-pipelines.yml": "azure-pipelines",
    "bal": "ballerina",
    "bat": "bat",
    "bats": "bats",
    "bzl": "bazel",
    "bf": "befunge",
    "bicep": "bicep",
    "bib": "bibtex",
    "biml": "biml",
    "bin": "code-text-binary",
    "rast": "biome_syntax_tree",
    "blade.php": "blade",
    "blitzbasic": "blitzbasic",
    "bolt": "bolt",
    "bsq": "bosque",
    "bru": "bruno",
    "buf.yaml": "buf",
    "lockb": "bun.lockb",
    "c": "c",
    "c3": "c3",
    "cal": "c-al",
    "cabal": "cabal",
    "capnp": "capnp",
    "casc": "casc",
    "cddl": "cddl",
    "ceylon": "ceylon",
    "cfc": "cfc",
    "cfm": "cfmhtml",
    "circom": "circom",
    "clojure": "clojure",
    "clojurescript": "clojurescript",
    "yml": "manifest-yaml",
    "cmake": "cmake",
    "cbl": "cobol",
    "ql": "ql",
    "coffee": "coffeescript",
    "cfml": "cfml",
    "confluence": "confluence",
    "ckbk": "cookbook",
    "instructions.md": "instructions",
    "cpp": "cpp",
    "cr": "crystal",
    "cs": "csharp",
    "css": "css",
    "wxss": "css",
    "acss": "css",
    "mcss": "css",
    "pcss": "css",
    "postcss": "css",
    "nss": "css",
    "ccss": "css",
    "less": "css",
    "scss": "css",
    "sass": "css",
    "csv": "csv",
    "feature": "cucumber",
    "cu": "cuda",
    "cypher": "cypher",
    "pyx": "cython",
    "dal": "dal",
    "dart": "dart",
    "dhall": "dhall",
    "html": "django-html",
    "diff": "diff",
    "d": "d",
    "hcl": "dockerbake",
    "dtx": "doctex",
    "env": "dotenv",
    "dot": "dotjs",
    "dox": "doxygen",
    "drawio": "drawio",
    "drl": "drools",
    "dtd": "dtd",
    "dust": "dustjs",
    "dylan": "dylan",
    "earthfile": "earthfile",
    "edge": "edge",
    "eex": "eex",
    "es": "es",
    "ex": "elixir",
    "elm": "elm",
    "erb": "erb",
    "erl": "erlang",
    "yaml": "esphome",
    "xlsx": "excel",
    "falcon": "falcon",
    "fql": "fql",
    "f": "fortran",
    "ftl": "ftl",
    "fs": "fsharp",
    "fthtml": "fthtml",
    "gspec": "galen",
    "gml": "gml-gms",
    "gcode": "gcode",
    "gen": "genstat",
    "git": "git-commit",
    "gleam": "gleam",
    "gjs": "glimmer-js",
    "glsl": "glsl",
    "glyphs": "glyphs",
    "gp": "gnuplot",
    "go": "go",
    "mod": "go.mod",
    "work": "go.work",
    "api": "goctl",
    "gd": "gdscript",
    "gradle.kts": "gradle-kotlin-dsl",
    "gr": "grain",
    "gql": "graphql",
    "gv": "dot",
    "grit": "grit",
    "groovy": "groovy",
    "haml": "haml",
    "hbs": "handlebars",
    "prg": "harbour",
    "hs": "haskell",
    "haxe": "haxe",
    "helm.tpl": "helm",
    "hjson": "hjson",
    "hlsl": "hlsl",
    "hosts": "hosts",
    "http": "http",
    "aff": "hunspell.aff",
    "hy": "hy",
    "hypr": "hypr",
    "icl": "icl",
    "imba": "imba",
    "4gl": "4GL",
    "ini": "ini",
    "ink": "ink",
    "iss": "innosetup",
    "io": "io",
    "janet": "janet",
    "java": "java",
    "js": "javascript",
    "mjs": "javascript",
    "cjs": "javascript",
    "es6": "javascript",
    "jake": "javascript",
    "jsm": "javascript",
    "jsx": "javascript",
    "njs": "javascript",
    "pac": "javascript",
    "sjs": "javascript",
    "ssjs": "javascript",
    "xsjs": "javascript",
    "xsjslib": "javascript",
    "jekyll": "jekyll",
    "jenkins": "jenkins",
    "jest-snap": "jest-snapshot",
    "jinja": "jinja",
    "json": "json",
    "jsonc": "jsonc",
    "jsonl": "jsonl",
    "jsonnet": "jsonnet",
    "json5": "json5",
    "jl": "julia",
    "id": "iodine",
    "k": "k",
    "kv": "kivy",
    "ks": "kos",
    "kt": "kotlin",
    "kusto": "kusto",
    "tex": "latex",
    "lark": "lark",
    "lat": "latino",
    "lean": "lean4",
    "flex": "lex",
    "ly": "lilypond",
    "lisp": "lisp",
    "lhs": "literate haskell",
    "log": "log",
    "lol": "lolcode",
    "lsl": "lsl",
    "lua": "lua",
    "m4": "m4",
    "mk": "makefile",
    "md": "markdown",
    "markdown": "markdown",
    "mdown": "markdown",
    "mkd": "markdown",
    "marko": "marko",
    "mat": "matlab",
    "ms": "maxscript",
    "mdx": "mdx",
    "mediawiki": "mediawiki",
    "mel": "mel",
    "mmd": "mermaid",
    "metal": "metal",
    "mcfunction": "bc-mcfunction",
    "mjml": "mjml",
    "pq": "powerquery",
    "mojo": "mojo",
    "ep": "mojolicious",
    "mongo": "mongo",
    "mson": "mson",
    "mv": "mv",
    "mvt": "mvt",
    "ne": "nearley",
    "nginx": "nginx",
    "nim": "nim",
    "nimble": "nimble",
    "nix": "nix",
    "nsi": "nsis",
    "nunjucks": "nunjucks",
    "nu": "nushell",
    "m": "objective-c",
    "mm": "objective-cpp",
    "ml": "ocaml",
    "o3": "ogone",
    "w": "abl",
    "things": "openhab",
    "org": "org",
    "pas": "pascal",
    "pddl": "pddl",
    "plan": "plan",
    "happenings": "happenings",
    "pl": "perl",
    "pl6": "perl6",
    "pgsql": "pgsql",
    "php": "php",
    "php4": "php",
    "php5": "php",
    "php7": "php",
    "phtml": "php",
    "phps": "php",
    "phpt": "php",
    "phar": "php",
    "aw": "php",
    "ctp": "php",
    "inc": "php",
    "php3": "php",
    "php8": "php",
    "module": "php",
    "theme": "php",
    "tpl": "php",
    "pine": "pine",
    "txt": "plaintext",
    "dbgasm": "platformio-debug.disassembly",
    "ddl": "plsql",
    "po": "po",
    "dib": "polyglot-notebook",
    "polymer": "polymer",
    "pony": "pony",
    "ps": "postscript",
    "ps1": "powershell",
    "prisma": "prisma",
    "pde": "pde",
    "pro": "prolog",
    "rules": "prometheus",
    "properties": "java-properties",
    "proto": "proto3",
    "pug": "jade",
    "pp": "puppet",
    "purs": "purescript",
    "arr": "pyret",
    "pyscript": "pyscript",
    "py": "python",
    "pyi": "python",
    "pyw": "python",
    "pyc": "python",
    "pyd": "python",
    "pyo": "python",
    "pxd": "python",
    "pxi": "python",
    "rpy": "python",
    "cpy": "python",
    "ipy": "python",
    "pyowo": "pythowo",
    "qvs": "qlik",
    "qml": "qml",
    "qs": "qsharp",
    "r": "r",
    "rkt": "racket",
    "raku": "raku",
    "cshtml": "razor",
    "raml": "raml",
    "re": "reason",
    "red": "red",
    "res": "rescript",
    "rst": "restructuredtext",
    "rex": "rexx",
    "tag": "riot",
    "ripple": "ripple",
    "rmd": "rmd",
    "rnc": "rnc",
    "robot": "robot",
    "rb": "ruby",
    "rbw": "ruby",
    "rake": "ruby",
    "gemspec": "ruby",
    "ru": "ruby",
    "rjs": "ruby",
    "rxml": "ruby",
    "rsel": "ruby",
    "builder": "ruby",
    "jbuilder": "ruby",
    "rabl": "ruby",
    "prawn": "ruby",
    "thor": "ruby",
    "rs": "rust",
    "sl": "s-lang",
    "san": "san",
    "sas": "SAS",
    "sbt": "sbt",
    "scad": "scad",
    "scala": "scala",
    "sce": "scilab",
    "sdl": "sdl",
    "code-search": "search-result",
    "shader": "shaderlab",
    "sh": "shellscript",
    "bash": "shellscript",
    "zsh": "shellscript",
    "ksh": "shellscript",
    "fish": "shellscript",
    "slang": "slang",
    "ice": "slice",
    "slim": "slim",
    "slint": "slint",
    "sln": "sln",
    "ss": "silverstripe",
    "sn": "sino",
    "eskip": "eskip",
    "smk": "snakemake",
    "code-snippets": "snippets",
    "snort": "snort",
    "sol": "solidity",
    "rq": "sparql",
    "sqf": "sqf",
    "sql": "sql",
    "nut": "squirrel",
    "stan": "stan",
    "bazel": "starlark",
    "do": "stata",
    "stencil": "stencil",
    "html.stencil": "stencil-html",
    "st.css": "stylable",
    "styled": "source.css.styled",
    "styl": "stylus",
    "svelte": "svelte",
    "svg": "svg",
    "swagger": "Swagger",
    "swift": "swift",
    "swig": "swig",
    "link": "systemd-conf",
    "sv": "systemverilog",
    "tt": "t4",
    "teal": "teal",
    "templ": "templ",
    "tt3": "tt",
    "tera": "tera",
    "tf": "terraform",
    "sty": "tex",
    "textile": "textile",
    "json-tmlanguage": "json-tmlanguage",
    "yaml-tmlanguage": "yaml-tmlanguage",
    "toit": "toit",
    "toml": "toml",
    "toon": "toon",
    "ttcn3": "ttcn",
    "tuc": "tuc",
    "twig": "twig",
    "ts": "typescript",
    "mts": "typescript",
    "cts": "typescript",
    "tsx": "typescriptreact",
    "typoscript": "typoscript",
    "ua": "uiua",
    "u": "unison",
    "vb": "vb",
    "wsf": "vbscript",
    "vm": "velocity",
    "vto": "vento",
    "v": "verilog",
    "vhdl": "vhdl",
    "vim": "viml",
    "vitest-snap": "vitest-snapshot",
    "volt": "volt",
    "vroom": "vroom",
    "vue": "vue",
    "vue2": "vue",
    "vue3": "vue",
    "vues": "vue",
    "vuex": "vue",
    "vuerc": "vue",
    "vy": "vyper",
    "wai": "wai",
    "wasm": "wasm",
    "wat": "wasm",
    "wast": "wasm",
    "wsm": "wasm",
    "wast.js": "wasm",
    "wit": "wasm",
    "witx": "wasm",
    "wy": "wenyan",
    "wgsl": "wgsl",
    "wt": "wikitext",
    "wl": "wolfram",
    "wurst": "wurstlang",
    "xcompose": "xcompose",
    "xmake.lua": "xmake",
    "xml": "xml",
    "xquery": "xquery",
    "xsl": "xsl",
    "bison": "yacc",
    "yang": "yang",
    "zig": "zig",
    "zip": "zip"
  },
  "fileNameToLanguageId": {
    "browserslist": "browserslist",
    ".browserslistrc": "browserslist",
    "caddyfile": "caddyfile",
    "cmakelists.txt": "cmake",
    "cmakecache.txt": "cmake-cache",
    "docker-compose.yml": "dockercompose",
    "docker-compose.yaml": "dockercompose",
    "compose.yaml": "dockercompose",
    "compose.yml": "dockercompose",
    "dockerfile": "dockerfile",
    "dockerfile.dev": "dockerfile",
    "dockerfile.prod": "dockerfile",
    "dockerfile.test": "dockerfile",
    ".editorconfig": "editorconfig",
    "justfile": "just",
    "meson.build": "meson",
    ".php-version": "php",
    "artisan": "php",
    "requirements.txt": "pip-requirements",
    "requirements-dev.txt": "pip-requirements",
    "requirements-test.txt": "pip-requirements",
    "requirements-prod.txt": "pip-requirements",
    "setup.py": "python",
    "setup.cfg": "python",
    ".python-version": "python",
    "pipfile": "python",
    "pipfile.lock": "python",
    "robots.txt": "robots-txt",
    "config.ru": "ruby",
    ".bashrc": "shellscript",
    ".zshrc": "shellscript",
    ".profile": "shellscript",
    ".bash_profile": "shellscript",
    ".bash_aliases": "shellscript",
    ".zprofile": "shellscript",
    "tiltfile": "tiltfile",
    ".vue-cli-rc": "vue",
    "yarn.lock": "yarnlock"
  }
}
